import { render, staticRenderFns } from "./PacedFulfillment.vue?vue&type=template&id=108aa460"
import script from "./PacedFulfillment.vue?vue&type=script&lang=js"
export * from "./PacedFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports